import { L3_PATHS } from 'Deer/constants/routes';
import queryString from 'query-string';
import { generatePath } from 'react-router-dom';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { routes } from 'constants/routes';

export const getOneOnOneInstancePagePath = ({
  masterId,
  instanceId,
  selectedCohort,
}: {
  masterId: number;
  instanceId: number;
  selectedCohort?: number;
}) => {
  let path;

  if (selectedCohort === -2) {
    path = L3_PATHS.team.directReports.oneOnOne.instancePage;
  } else if (selectedCohort === -3) {
    path = L3_PATHS.team.allReports.oneOnOne.instancePage;
  } else {
    path = L3_PATHS['my-data'].oneOnOne.instancePage;
  }

  const redirectPath = checkNewNavEnabled()
    ? generatePath(path, {
        instanceId,
        masterId,
      })
    : generatePath(routes.oneOnOne.instanceRabbit, {
        instanceId,
        masterId,
      });
  return redirectPath;
};

export const getLegacyOneOnOneInstancePagePath = ({ legacyInstanceId }: { legacyInstanceId: number }) => {
  const redirectPath = generatePath(routes.oneOnOne.legacyInstance, {
    instanceId: legacyInstanceId,
  });
  return redirectPath;
};
